import { render, staticRenderFns } from "./MedicalRepRates.vue?vue&type=template&id=10630c11"
import script from "./MedicalRepRates.vue?vue&type=script&lang=js"
export * from "./MedicalRepRates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports